import './main.scss';
import { Logo } from '../components/logo/logo';
import { IAccountPlan } from '../interface/plan';
import { AppContext } from '../context/appContext';
import React, { createRef, useContext, useCallback, useEffect, useState } from 'react';
import { getAccountPlan } from '../dataServices/getAccountPlan';
import { PageHeader } from '../components/pageHeader/pageHeader';
import { $window, getQueryString, openWindow } from '@umu/umu-dom';
import { PageHeaderNav } from '../components/pageHeaderNav/pageHeaderNav';
import ThemeConfigProvider from '../../../common/src/config/theme/themeConfig';
import { PageHeaderRight } from '../components/pageHeaderRight/pageHeaderRight';
import SearchInputForContent from '@umu/umu-search/src/searchInputForContent/searchInputForContent';
import { commonHeaderEventEmitter, registerCommonHeaderEventEmitterForWindow } from '../services/eventEmitter';

export function MainPage() {
    const appContext = useContext(AppContext);

    const headerType = getQueryString('headerType') || '';
    const keyWords = decodeURIComponent(getQueryString('keyWords') || '');

    const { isInUSE, onLogoClick } = appContext.state;
    const [accountPlan, setAccountPlan] = useState<IAccountPlan | null>(null);
    const headerNavRef = createRef();
    const [microPageReceiveData, setMicroPageReceiveData] = useState<Object>({});

    const receiveFromMicroPageMessageCallback = (data: Object) => {
        setMicroPageReceiveData(data);
    };

    const addEventListenerCommonHeaderEventEmitter = () => {
        commonHeaderEventEmitter.on('commonHeaderEvent', (_data: any) => {
            const { name, source, data } = _data;

            if (name !== 'commonHeaderEvent' || source !== 'microPage') {
                return;
            }

            receiveFromMicroPageMessageCallback(data);
        });
    };

    useEffect(() => {
        if (isInUSE) {
            addEventListenerCommonHeaderEventEmitter();
            registerCommonHeaderEventEmitterForWindow();
        }

        getAccountPlan().then((ret) => {
            if (!ret.error_code && ret.data) {
                ret.data.teacher_status = Number(ret.data.teacher_status);
                setAccountPlan(ret.data);
            }
        });

        return () => {
            ($window as any).eventCenterForSearchInput.clearDataListener();
        };
    }, []);

    const handleLogoLoaded = useCallback(() => {
        if (headerNavRef && headerNavRef.current) {
            (headerNavRef.current as any)?.updateNavLayout();
        }
    }, [headerNavRef, headerNavRef.current]);

    const renderLogo = useCallback(() => {
        return <Logo entry={onLogoClick} trackEvent="" hideDefaultLogo={false} onLogoLoaded={handleLogoLoaded}></Logo>;
    }, []);

    const renderNavs = () => {
        if (!accountPlan) {
            return null;
        }
        return (
            <div className="page-header-container">
                <PageHeaderNav ref={headerNavRef} versionType={accountPlan.teacher_status} />
                <PageHeaderRight accountPlan={accountPlan} />
            </div>
        );
    };

    const goUseHome = () => {
        openWindow(`${location.origin}/use`, '_self');
    };

    const renderUSEHeaderSearch = () => {
        return (
            <div className="use-header-search-container">
                <SearchInputForContent
                    eid=""
                    sort=""
                    categoryId=""
                    keyWords={keyWords}
                    goUseHome={goUseHome}
                    inputType="useCommon"
                    headerType={Number(headerType)}
                    {...microPageReceiveData}
                />
            </div>
        );
    };

    if (isInUSE) {
        return (
            <div className="main-page in-use">
                <PageHeader showFixedHolder={false} renderLogo={renderLogo}>
                    {accountPlan && (
                        <div className="page-header-container">
                            {renderUSEHeaderSearch()}
                            <PageHeaderRight accountPlan={accountPlan} />
                        </div>
                    )}
                </PageHeader>
            </div>
        );
    }

    return (
        <ThemeConfigProvider rootClassNameKey="common-header-page-header">
            <div className="main-page">
                <PageHeader showFixedHolder={false} renderLogo={renderLogo}>
                    {renderNavs()}
                </PageHeader>
            </div>
        </ThemeConfigProvider>
    );
}
